import type { LocaleCode } from './locales.js'

/**
 * Lazily fetched catalogs; Vite gives each its own chunk.
 *
 * Kept apart from `locales.ts` so the pure registry — codes, labels, matching
 * rules — can be imported (and tested) without pulling in dynamic imports of
 * every catalog.
 */
export const LOCALE_LOADERS: Record<
  Exclude<LocaleCode, 'en'>,
  () => Promise<{ default: Record<string, unknown> }>
> = {
  de: () => import('./messages/de.js'),
  fr: () => import('./messages/fr.js'),
  es: () => import('./messages/es.js'),
  it: () => import('./messages/it.js'),
  ja: () => import('./messages/ja.js'),
  'zh-Hans': () => import('./messages/zh-Hans.js'),
  ko: () => import('./messages/ko.js'),
}
